/* The footer always sits at the bottom of the window: the shell fills the viewport height and the
   body grows, so short pages show no empty space under the footer. */
.shell {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  min-height: 100dvh;
  background: var(--surface-ground);
}

.skip {
  position: absolute;
  top: 8px;
  left: 8px;
  z-index: 100;
  padding: 12px 16px;
  border-radius: var(--radius-sm);
  background: var(--white);
  color: var(--brand-navy);
  font-weight: var(--fw-semibold);
  transform: translateY(-200%);
}

.skip:focus {
  transform: none;
}

.body {
  display: flex;
  flex: 1 0 auto;
  flex-wrap: wrap;
  align-items: stretch;
}

.main {
  flex: 999 1 640px;
  min-width: 0;
  outline: none;
}

/* Page body under the hero: max 1320 px with 32 px gutters (DESIGN-SPEC §2.4). */
.page {
  max-width: var(--container-max);
  margin: 0 auto;
  padding: 36px var(--content-gutter) 72px;
}

/* A page that uses the whole window (APP-130 D96: Letters): no 1,320 px limit, same gutters. */
.pageFull {
  max-width: none;
}

/* A section's sidebar beside the page (NAV2), as HOME2 lays the queue out. */
.withNav {
  display: grid;
  grid-template-columns: 270px minmax(0, 1fr);
  gap: 28px;
  align-items: start;
}

.navMain {
  min-width: 0;
}

@media (max-width: 900px) {
  .withNav {
    grid-template-columns: minmax(0, 1fr);
  }
}

/* Two columns that wrap: main flexible, side about 340 px. */
.columns {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 28px;
}

.mainColumn {
  display: flex;
  flex: 999 1 600px;
  flex-direction: column;
  gap: 28px;
  min-width: 0;
}

.wideMain > .mainColumn {
  flex-basis: 840px;
}

.sideColumn {
  display: flex;
  flex: 1 1 340px;
  flex-direction: column;
  gap: 28px;
  min-width: 0;
}

.stack {
  display: flex;
  flex-direction: column;
  gap: 28px;
}

.grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(220px, 100%), 1fr));
  gap: 16px;
}
